export const ALREADY_READ_ERROR = 'Este pacote já foi lido';

export const WRONG_PACKAGE = 'Este não é o pacote correto';

export const PRODUCT_NOT_FOUND = 'Produto não encontrado';

export const INVALID_QUANTITY = 'Informe a quantidade';
